module.exports = __webpack_public_path__ + "static/media/file-upload-done.3d3939dd.svg";